module.exports = __webpack_public_path__ + "img/background-logos.9f846a71.png";